
































import mixins from 'vue-typed-mixins';
import DashboardUtils from '@/utils/DashboardUtils';
import TileNotifications from '@/components/dashboard/tiles/TileNotifications.vue';
import TileParticipations from '@/components/dashboard/tiles/TileParticipations.vue';
export default mixins().extend({
  components: {
    TileParticipations,
    TileNotifications,
  },

  computed: {},

  methods: {},
});
